import { CompleteStore } from '../../../../../reducers/reducerTypes';

export const getWindowWidth = (state: CompleteStore): number => {
	return state.constants.windowWidth;
};
